import { Dropdown } from '@components';
import { useAppContext } from '@molecules';

type CampaignFilterProps = {
  value?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
};

const CampaignFilter: React.FC<CampaignFilterProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  const { meta, setCampaignFilter } = useAppContext();

  return (
    <Dropdown
      grow={false}
      placeholder="Campaign"
      options={[{ value: '', label: 'All Campaigns' }, ...meta.campaigns]}
      value={value || meta.initialCampaignFilter}
      disabled={disabled}
      onChange={value => {
        onChange?.(value);
        setCampaignFilter(value);
      }}
    />
  );
};

export default CampaignFilter;
